<template>
<div>
  <el-dialog
    title="编辑客户信息"
    custom-class="dialog"
    :visible.sync="showDialog"
    width="742px"
    @open="handleOpen"
    :close-on-click-modal="false"
    :before-close="cancel"
    :append-to-body="true"
  >
    <div>
      <el-form :model="editDetailData2"  label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="companyName">
              <el-input 
                class="disableinput"
                size="small" 
                v-model="editDetailData2.companyName" 
                maxlength="50" 
                :disabled="true" 
                style="width:220px;color: #98A3B7;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户来源" prop="region">
              <el-select
                  class="disableinput"
                  size="small"
                  style="width:220px;color: #98A3B7;" 
                  v-model="editDetailData2.source"
                  placeholder="请选择"
                  :disabled="true"
              >
                <el-option
                  v-for="item in customerSourceOptions"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="客户等级" prop="region">
              <el-select
                  size="small"
                  style="width:220px;"
                  v-model="editDetailData2.level"
                  placeholder="请选择"
              >
                <el-option
                  v-for="item in customerLevelOptions"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业" prop="region">
              <el-select
                style="width:220px;"
                v-model="editDetailData2.industry"
                filterable
                allow-create
                default-first-option
                reserve-keyword
                clearable
                @input.native="regionInput"
                ref="regionSelect"
                placeholder="请输入">
                <el-option
                  v-for="item in industryOptionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="雇员数量" prop="">
              <el-input 
                v-model="editDetailData2.employees" 
                maxlength="9"
                size="small" 
                style="width:220px;" 
                @input="editDetailData2.employees = editDetailData2.employees.replace(/^(0+)|[^\d]+/g,'')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:0;">
            <el-form-item label="企业年收入" prop="">
              <el-input 
                v-model="editDetailData2.revenue"
                maxlength="18"
                class="income-input" 
                size="small" 
                style="width:130px;"
                @input="editDetailData2.revenue = editDetailData2.revenue.replace(/^(0+)|[^\d]+/g,'')"
              ></el-input>
              <el-select
                  size="small"
                  style="width:90px;"
                  v-model="editDetailData2.currency"
                  placeholder="请选择"
                  class="currency-input"
              >
                <el-option
                  v-for="item in currencyOptions"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

         <el-row :gutter="10">
           <el-col :span="12"  >
            <el-form-item label="邮政编码" prop="">
              <el-input 
                v-model="editDetailData2.zipCode" 
                maxlength="20" 
                size="small" 
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" style="padding-left:0;">
            <el-form-item label="公司网址" prop="">
              <el-input 
                v-model="editDetailData2.website" 
                resize='none' 
                maxlength="2000" 
                size="small" 
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> 

        <el-row class="area-row">
          <el-form-item label="所在区域" prop="" >
            <!-- 国家 -->
            <el-col :span="8">
              <el-select 
                v-model="editDetailData2.country" 
                placeholder="请选择" 
                clearable
                filterable
                @clear="handleClearCountry"
                @change="handleChangeCountry"
                style="width:172px"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            </el-col>
            <!-- 省份 -->
            <el-col :span="8">
              <el-select 
                v-model="editDetailData2.state" 
                placeholder="请选择"
                clearable
                filterable
                @clear="handleClearProvince"
                @change="handleChangeProvince"
                style="width:172px"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            </el-col>
            <!-- 城市 -->
            <el-col :span="8">
              <el-select 
                v-model="editDetailData2.city" 
                placeholder="请选择"
                clearable
                filterable
                :disabled="cityList.length === 0 "
                style="width:172px"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.codeValue"
                  :label="item.name"
                  :value="item.codeValue">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-row>
        
        <el-form-item label="详细地址" prop="" style="position:relative; ;left:-8px;">
          <el-input 
            v-model="editDetailData2.address" 
            type="textarea" 
            resize='none' 
            maxlength="500" 
            size="small" 
            style="width:580px;"
          ></el-input>
        </el-form-item>
          
        <el-form-item label="备注" prop="" style="position:relative; ;left:-8px;">
          <el-input 
            v-model="editDetailData2.remark" 
            class="remark-input"
            type="textarea" 
            resize='none' 
            maxlength="500" 
            style="width:580px;color: #98A3B7;"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small" style="color:#16181A">取 消</el-button>
      <el-button type="primary" @click="confirm" size="small">确 定</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import TreeSelect from '@/components/common/TreeSelect';
import { getDictByType, } from '@/utils/api/common.js';
import { editCustomer } from '@/utils/api/customerdetail';
import { industryByKeyword } from '@/utils/api/edmSubject'
import { commonDictCountryList, commonDictProvinceList, commonDictCityList } from '@/utils/api/area.js'

export default {
  props: ['copyDetailData'],
  watch: {
    copyDetailData: {
      handler(newVal) {
        this.editDetailData2 = JSON.parse(JSON.stringify(newVal))
        this.editDetailData2.currency = this.editDetailData2.currency> 0? this.editDetailData2.currency :92
        this.editDetailData2.city = this.editDetailData2.city> 0? this.editDetailData2.city :''
      },
      immediate: true,
      deep: true,
    }
  },
  components: {
    TreeSelect,
  },
  data(){
    return {
      showDialog: false,
      customerSourceOptions: [],
      customerLevelOptions: [],
      customerIndustryOptions: [],
      currencyOptions:[],
      countryList: [],
      provinceList: [],
      cityList: [],
      editDetailData2: {},
      industryOptionList: [],
    }
  },
   methods: {
    // 获取国家信息
    getCountry(){
       commonDictCountryList()
       .then(res=>{
        if(res.rspResult.bizCode == 200){
          this.countryList = res.rspListData.list || []
        }
       })
       .catch(err=>console.error('获取国家失败',err))
    },
    // 获取省份
    getState(){
      if(this.editDetailData2.country){
        commonDictProvinceList(this.editDetailData2.country)
          .then(res=>{
            if(res.rspResult.bizCode == 200){
              this.provinceList = res.rspListData.list || []
            }
          })
          .catch(err=>console.error('获取省份失败',err))
      }
    },
    // 获取城市
    getCity(){
      if(this.editDetailData2.state){
        commonDictCityList(this.editDetailData2.state)
          .then(res=>{
            if(res.rspResult.bizCode == 200){
              this.cityList = res.rspListData.list || []
            }
          })
          .catch(err=>console.error('获取城市失败',err))
      }
    },
    // 切换国家
    handleChangeCountry(val) {
      this.editDetailData2.country = val;
      this.editDetailData2.state = "";
      this.editDetailData2.city = "";
      this.cityList = [];
      if(val){
        this.getState();
      }
    },
    // 切换省份
    handleChangeProvince(val) {
      this.editDetailData2.state = val;
      this.editDetailData2.city = "";
      if(val){
        this.getCity();
      }
    },
    // 清除国家
    handleClearCountry() {
      this.editDetailData2.state = "";
      this.editDetailData2.city = "";
      this.provinceList = [];
      this.cityList = [];
    },
    // 清除省份
    handleClearProvince() {
      this.editDetailData2.city = "";
      this.cityList = [];
    },
    // 初始化选项数据
    async getInitData() {
      try {
        const res = await getDictByType([
          { key: 'saas_supplier_customer_source' },
          { key: 'saas_customer_industry' },
          { key: 'saas_supplier_customer_level' },
          { key: 'currency' },
          { key: 'saas_supplier_customer_title'}
        ])
        if (res.rspResult.bizCode === 200) {
          const {
            codeMap: {
              saas_supplier_customer_source,
              saas_supplier_customer_level,
              saas_customer_industry,
              currency,
              saas_supplier_customer_title
            },
          } = res.data
          this.customerSourceOptions = saas_supplier_customer_source || []
          this.customerLevelOptions = saas_supplier_customer_level || []
          this.customerIndustryOptions = saas_customer_industry || []
          this.currencyOptions = currency || [],
          this.titleListOptions = saas_supplier_customer_title || []
        }
      } catch(err) {
        console.error("❌ ~ file: editorDialog.vue:383 ~ getInitData ~ err:", err)
      }
    },
    // 取消编辑信息
    cancel(){
      this.$emit('getCustomerDetail',this.editDetailData2.id);
      this.showDialog = false;
    },
    // 提交编辑信息
    confirm(){
      const params = {
        address: this.editDetailData2.address?.trim() ,
        source: this.editDetailData2.source,
        companyName: this.editDetailData2.companyName,
        employees: this.editDetailData2.employees,
        id: this.editDetailData2.id,
        level: this.editDetailData2.level,
        revenue: this.editDetailData2.revenue,
        website: this.editDetailData2.website,
        zipCode: this.editDetailData2.zipCode,
        country: this.editDetailData2.country,
        state: this.editDetailData2.state,
        city: this.editDetailData2.city ==''? 0 : this.editDetailData2.city,
        remark: this.editDetailData2.remark?.trim(),
        currency: this.editDetailData2.currency ,
        
      }
      // 判断行业的类型，如果字符串，代表是自定义的
      if(typeof this.editDetailData2.industry === 'string') {
        params.customIndustry = this.editDetailData2.industry || undefined
      } else {
        // 数字类型代表是id
        params.industry = this.editDetailData2.industry || undefined
      }
      editCustomer(params)
      .then((res)=>{
        if(res.rspResult.bizCode == 200) {
          this.$message({
            type:'success',
            message:'保存成功'
          })
          this.$emit('getCustomerDetail',this.editDetailData2.id)
          this.$emit('getLogList')
          this.showDialog = false;

        }
      })
      .catch((err)=>console.error('编辑客户信息失败',err))
    },
    // 弹框打开时触发
    handleOpen(){
      this.getCountry()
      this.getState()
      this.getCity()
      this.getIndustryList()
    },
   
   autocompleteSelect(val) {
    this.editDetailData2.industryStr = val.name
   },

    // 当行业输入值发生变化时
    regionInput(value) {
      try {
        var str = this.$refs.regionSelect.$data.selectedLabel// 此属性得到输入的文字
        // 控制的js
        if(str.length>100){this.$refs.regionSelect.$data.selectedLabel = str.substr(0,100)}
      } catch(err) {
        console.error("❌ ~ file: editorDialog.vue:461 ~ regionInput ~ err:", err)
      }
    },

    async getIndustryList(val) {
        try {
          const res = await industryByKeyword({keyword: ''})
          if(res.rspResult.bizCode === 200) {
            this.industryOptionList = res.rspListData.list
          }
        } catch(err) {
          console.error("❌ ~ file: editorDialog.vue:459 ~ getIndustryList ~ err:", err)
        }
    },
  },
  created(){
    this.getInitData()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .disableinput{
  .el-input__inner{
    color: #4F5D78 !important;
  }
}
::v-deep.el-textarea{
  .el-textarea__inner{
    min-height: 60px !important;
    color:#16181A;
    font-size: 14px;
  }
 
}
::v-deep.remark-input{
  .el-textarea__inner{
    min-height: 64px !important;
    color:#16181A;

  }
}
::v-deep .income-input{
  .el-input__inner{
    border-right: none;
    border-radius: 4px 0 0 4px;
  }
}
::v-deep .currency-input{
  .el-input__inner{
    padding-left: 10px;
    background: #F5F7FA;
    border-radius: 0px 4px 4px 0 ;
  }
}

::v-deep  .dialog{
  .el-row{
    left: -8px;
    .el-col {
      &:last-child {
        padding-left: 10px !important;
      }
    }
  }

  .area-row {
    .el-col {
      padding-left: 5px !important;
      &:first-child {
        padding-left: 0 !important;
      }
    }
  }
  
  .el-dialog__header{
    padding: 24px 32px 0 32px;
  }
  .el-dialog__body{
    padding-bottom: 0;
  }
  .el-dialog__footer{
    padding: 8px 32px 28px 32px;
  }
  .el-dialog__headerbtn{
    width: 14px;
    top: 32px;
    right: 32px;
  }
  .el-dialog__title{
    font-size: 16px;
    color: #16181A;
    font-weight: 500;
  }
  .el-form-item__label{
    font-size: 14px;
    color:#4F5D78
  }
  .el-input__inner{
    font-size: 14px;
    color: #16181A;
  }
  .el-button--small{
    padding: 9px 13px;
    // 
  }
  .dialog-footer {
    .el-button {
      font-size: 14px;
    }
  }
}
::v-deep .el-tag {
  max-width: calc(100% - 70px);
  .el-select__tags-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
// input type:number 样式
::v-deep input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
}
::v-deep input::-webkit-outer-spin-button{
  -webkit-appearance: none !important;
}
</style>